import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAuthHeaders } from "../../utils/apiHeaders";

var API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export var fetchMyBooks = createAsyncThunk(
  "myBooks/fetchMyBooks",
  async function (language, thunkApi) {
    try {
      var response = await fetch(API_BASE_URL + "/my-books", {
        method: "GET",
        signal: thunkApi.signal,
        headers: getAuthHeaders(language),
      });

      var responseData = await response.json();

      if (!response.ok) {
        return thunkApi.rejectWithValue({
          message: responseData.message || "Unable to retrieve your books",
        });
      }

      return Array.isArray(responseData.data) ? responseData.data : [];
    } catch (error) {
      return thunkApi.rejectWithValue({
        message: error.message || "Unable to connect to the server",
      });
    }
  }
);

var initialState = {
  books: [],
  loading: false,
  error: "",
  loaded: false,
};

var myBooksSlice = createSlice({
  name: "myBooks",
  initialState: initialState,
  reducers: {},
  extraReducers: function (builder) {
    builder
      .addCase(fetchMyBooks.pending, function (state) {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchMyBooks.fulfilled, function (state, action) {
        state.loading = false;
        state.loaded = true;
        state.books = action.payload;
      })
      .addCase(fetchMyBooks.rejected, function (state, action) {
        state.loading = false;
        state.error =
          (action.payload && action.payload.message) || "Unable to retrieve your books";
      });
  },
});

export default myBooksSlice.reducer;
